module.exports = __webpack_public_path__ + "img/Dinner.96498196.svg";